// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SuperAdminUserInfoGrid {
  display: grid;
  grid-template-columns: 220px 1fr;
  gap: 8px 16px;
  max-width: 980px;
}

.SuperAdminUserTabContent {
  background: #fff;
}

.SuperAdminUserJsonBlock {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  max-height: 360px;
  overflow: auto;
  padding: 12px;
  white-space: pre-wrap;
}

.SuperAdminUserOverviewActions {
  max-width: 980px;
}

.SuperAdminUserEditGrid {
  display: grid;
  grid-template-columns: 220px minmax(280px, 520px);
  gap: 10px 16px;
  max-width: 980px;
}

.SuperAdminUserEditGrid label {
  font-weight: 600;
  margin: 0;
  padding-top: 5px;
}

.SuperAdminUserNotificationChannels {
  max-width: 1180px;
}

.SuperAdminUserDefaultChannelRow {
  align-items: center;
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
}

.SuperAdminUserAddChannelForm {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 12px;
}

.SuperAdminUserChannelTable th,
.SuperAdminUserChannelTable td {
  vertical-align: middle;
}

.SuperAdminUserMergePanel {
  background: #f8fbff;
  border: 1px solid #bdd7ee;
  border-radius: 8px;
  max-width: 980px;
  padding: 18px;
}

.SuperAdminUserMergeCandidates {
  display: grid;
  gap: 8px;
  max-height: 260px;
  overflow: auto;
}

.SuperAdminUserMergeCandidate {
  align-items: flex-start;
  background: #fff;
  border: 1px solid #d9e2ea;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  padding: 10px 12px;
  text-align: left;
}

.SuperAdminUserMergeCandidate:hover {
  border-color: #4b8fc8;
}

.SuperAdminUserMergeCandidate span {
  color: #6c757d;
  font-size: 12px;
}

.SuperAdminUserMergeSchoolOptions {
  z-index: 20;
}

.SuperAdminUserMergeCandidateHeader {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 6px 14px;
  justify-content: space-between;
  width: 100%;
}

.SuperAdminUserMergeCandidateIdentity {
  color: #6c757d;
  font-size: 12px;
  margin-top: 4px;
}

.SuperAdminUserMergeCandidateRoles {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/views/SuperAdminApp/User/SuperAdminUser.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iDAAiD;EACjD,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB","sourcesContent":[".SuperAdminUserInfoGrid {\n  display: grid;\n  grid-template-columns: 220px 1fr;\n  gap: 8px 16px;\n  max-width: 980px;\n}\n\n.SuperAdminUserTabContent {\n  background: #fff;\n}\n\n.SuperAdminUserJsonBlock {\n  background: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  max-height: 360px;\n  overflow: auto;\n  padding: 12px;\n  white-space: pre-wrap;\n}\n\n.SuperAdminUserOverviewActions {\n  max-width: 980px;\n}\n\n.SuperAdminUserEditGrid {\n  display: grid;\n  grid-template-columns: 220px minmax(280px, 520px);\n  gap: 10px 16px;\n  max-width: 980px;\n}\n\n.SuperAdminUserEditGrid label {\n  font-weight: 600;\n  margin: 0;\n  padding-top: 5px;\n}\n\n.SuperAdminUserNotificationChannels {\n  max-width: 1180px;\n}\n\n.SuperAdminUserDefaultChannelRow {\n  align-items: center;\n  background: #fff;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 12px;\n}\n\n.SuperAdminUserAddChannelForm {\n  background: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  padding: 12px;\n}\n\n.SuperAdminUserChannelTable th,\n.SuperAdminUserChannelTable td {\n  vertical-align: middle;\n}\n\n.SuperAdminUserMergePanel {\n  background: #f8fbff;\n  border: 1px solid #bdd7ee;\n  border-radius: 8px;\n  max-width: 980px;\n  padding: 18px;\n}\n\n.SuperAdminUserMergeCandidates {\n  display: grid;\n  gap: 8px;\n  max-height: 260px;\n  overflow: auto;\n}\n\n.SuperAdminUserMergeCandidate {\n  align-items: flex-start;\n  background: #fff;\n  border: 1px solid #d9e2ea;\n  border-radius: 6px;\n  display: flex;\n  flex-direction: column;\n  padding: 10px 12px;\n  text-align: left;\n}\n\n.SuperAdminUserMergeCandidate:hover {\n  border-color: #4b8fc8;\n}\n\n.SuperAdminUserMergeCandidate span {\n  color: #6c757d;\n  font-size: 12px;\n}\n\n.SuperAdminUserMergeSchoolOptions {\n  z-index: 20;\n}\n\n.SuperAdminUserMergeCandidateHeader {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px 14px;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.SuperAdminUserMergeCandidateIdentity {\n  color: #6c757d;\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n.SuperAdminUserMergeCandidateRoles {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
